<template>
    <div :id="logoId" class="text-white text-xl">
        <Link class="block md:justify-center" :href="$route('dashboard')" v-if="!showOnPrintOnly">
           <img class="logo object-contain" alt="logo" :src="logoUrl"/>
        </Link>
        <img class="logo object-contain" alt="logo" :src="logoUrl" v-if="showOnPrintOnly"/>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        image: String,
        showOnPrintOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            logoId: 'logo'
        }
    },
    created() {
        this.logoId = (this.id && this.id.length > 0 ) ? this.id : 'logo'
    },
    computed: {
        logoUrl() {
            return require('../../img/' + this.image);
        }
    }
}
</script>
